import { FC } from 'react';
import { Route, Switch, useInitializeRoute } from './ReactRouteUtils';
import { Ng2React } from '../../common/util/Ng2React';
import dashboardPage from '../../legacy/app/dashboard/dashboardPage';
import dashboardIndexPage from '../../legacy/app/dashboardIndex/dashboardIndexPage';
import { ProtectedComponentWrapper } from '../../common/ProtectedComponentUtils';
import { dashboardsFeaturesEndpointMap } from './dashboardsFeaturesEndpointMap';
import { ForbiddenComponent } from '@splunk/olly-common/ForbiddenComponent';
import snapshotDashboardPage from '../../legacy/app/dashboard/snapshotDashboardPage';

export const DashboardRoutes: FC = () => {
    const routeUtilsBootStrap = useInitializeRoute();

    return (
        <Switch>
            <Route
                exact
                path={['/dashboards', '/dashboards/:orgID']}
                title="Dashboards"
                straps={[routeUtilsBootStrap]}
            >
                <ProtectedComponentWrapper
                    endpoints={dashboardsFeaturesEndpointMap.viewDashboardIndexPage}
                    fallbackUi={<ForbiddenComponent />}
                >
                    <Ng2React name="dashboardIndexPage" definition={dashboardIndexPage} />
                </ProtectedComponentWrapper>
            </Route>

            <Route
                exact
                path={['/page/:groupId', '/dashboard/:dashboardID']}
                title="Dashboard"
                straps={[routeUtilsBootStrap]}
                reloadWithParams="path"
            >
                <ProtectedComponentWrapper
                    endpoints={dashboardsFeaturesEndpointMap.viewDashboardPage}
                    fallbackUi={<ForbiddenComponent />}
                >
                    <Ng2React name="dashboardPage" definition={dashboardPage} />
                </ProtectedComponentWrapper>
            </Route>

            <Route
                exact
                path="/temp/dashboard/:snapshotID"
                title="Dashboard"
                straps={[routeUtilsBootStrap]}
                reloadWithParams="path"
            >
                <ProtectedComponentWrapper
                    endpoints={dashboardsFeaturesEndpointMap.viewDashboardPage}
                    fallbackUi={<ForbiddenComponent />}
                >
                    <Ng2React name="snapshotDashboardPage" definition={snapshotDashboardPage} />
                </ProtectedComponentWrapper>
            </Route>

            {/* Export route for non-interactive dashboard rendering */}
            <Route
                exact
                path={['/_/dashboard/export/:dashboardID']}
                title="Dashboard Export"
                straps={[routeUtilsBootStrap]}
                reloadWithParams="path"
            >
                <ProtectedComponentWrapper
                    endpoints={dashboardsFeaturesEndpointMap.viewDashboardPage}
                    fallbackUi={<ForbiddenComponent />}
                >
                    <Ng2React name="dashboardPage" definition={dashboardPage} captureMode={true} />
                </ProtectedComponentWrapper>
            </Route>
        </Switch>
    );
};
